import LogRocket from 'logrocket';

import { createApp } from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueClickAway from 'vue3-click-away';
import HomeBookingForm from './vue/components/frontend/booking/HomeBookingForm.vue';
import ProductSelectionCard from './components/frontend/ProductSelectionCard.vue';
import AlertPopup from './components/frontend/AlertPopup.vue';
import LoginForm from './components/frontend/LoginForm.vue';
import SignInForm from './vue/components/frontend/auth/LoginForm.vue';
import BookingDetailsForm from './components/frontend/BookingDetailsForm.vue';
import PaymentForm from './components/frontend/PaymentForm.vue';
import RegisterForm from './components/frontend/RegisterForm.vue';
import UserDetailsForm from './components/frontend/UserDetailsForm.vue';
import EditBookingForm from './components/frontend/EditBookingForm.vue';
import RetrieveBookingForm from './components/frontend/RetrieveBookingForm.vue';
import ForgotPasswordForm from './components/frontend/ForgotPasswordForm.vue';
import PasswordResetForm from './components/frontend/PasswordResetForm.vue';
import CarparkSelectionCard from './components/CarparkSelectionCard.vue';
import SummaryCard from './components/frontend/Booking/SummaryCard.vue';
import QuickBookingForm from './components/frontend/QuickBookingForm.vue';
import vehicleMakeList from './globals/VehicleMakeList';
import AccountBookingCard from './components/AccountBookingCard.vue';
import StripePaymentEditOrderForm from './components/StripePaymentEditOrderForm.vue';
import SectionCard from './components/frontend/SectionCard.vue';
import NewSectionCard from './vue/components/frontend/globals/SectionCard.vue';
import EditBookingSummaryCard from './components/frontend/Booking/EditBookingSummaryCard.vue';
import MapDirectionsModal from './components/MapDirectionsModal.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';
import FallbackStoreBookingButton from './components/frontend/Payment/FallbackStoreBookingButton.vue';
import SelectInput from './vue/components/frontend/globals/SelectInput.vue';
import AppButton from './vue/components/frontend/globals/AppButton.vue';
import AlertView from './vue/components/frontend/globals/AlertView.vue';
import NewSummaryCard from './vue/components/frontend/booking/SummaryCard.vue';
import NewQuickBookingForm from './vue/components/frontend/booking/QuickBookingForm.vue';
import TextInput from './components/TextInput.vue';
import VerifyEmailBanner from './vue/components/frontend/auth/VerifyEmailBanner.vue';

require('./bootstrap');

if (window.location.hostname.includes('.com')) {
    LogRocket.init('oaoofw/lowcostairportparking');
}

const app = createApp({
    data() {
        return {
            showMenu: false,
            showModal: false,
            showLoginForm: false,
            showAlert: false,
            alertMessage: '',
            alertSuccess: true,
            total: 0,
            originalTotal: null,
            vehicles: [],
            showMapModal: false,
            session: null,
        };
    },
    methods: {
        sessionUpdate(session) {
            this.session = session;
        },
        vehicleUpdate(vehicles) {
            this.vehicles = vehicles;
        },
        showAlertWithMessage(details) {
            this.alertMessage = details.message;
            this.showAlert = true;
            this.alertSuccess = details.isSuccess;

            setTimeout(() => {
                this.showAlert = false;
            }, 3000);
        },

        priceChange(prices) {
            if (typeof prices.vehicles !== 'undefined') {
                this.vehicles = prices.vehicles;
            } else {
                this.vehicles[0].type.price = Number(prices.new);
                this.vehicles[0].type.original_price = Number(prices.original);
            }

            this.calculateTotal();
        },

        calculateTotal() {
            let total = 0;
            this.vehicles.forEach((vehicle) => {
                total += vehicle.type.price;
                total += vehicle.valet?.price ?? 0;
            });

            this.total = total;
        },
        logout() {
            axios.delete('/api/login/sign-out')
                .then((response) => {
                    window.location.href = '/';
                });
        },
    },
    components: {
        CarparkSelectionCard,
        HomeBookingForm,
        ProductSelectionCard,
        AlertPopup,
        LoginForm,
        BookingDetailsForm,
        PaymentForm,
        RegisterForm,
        UserDetailsForm,
        EditBookingForm,
        RetrieveBookingForm,
        ForgotPasswordForm,
        PasswordResetForm,
        SummaryCard,
        EditBookingSummaryCard,
        SectionCard,
        QuickBookingForm,
        AccountBookingCard,
        StripePaymentEditOrderForm,
        MapDirectionsModal,
        CookieConsentBanner,
        FallbackStoreBookingButton,
        NewSummaryCard,
        NewQuickBookingForm,
        SignInForm,
        VerifyEmailBanner,
    },
});

/**
 * Filters
 */
app.config.globalProperties.$filters = {
    money(value) {
        if (typeof value !== 'number' || isNaN(value)) {
            return '£0.00';
        }
        return `£${value.toFixed(2)}`;
    },
};

/**
 * Global Properties
 */
app.config.globalProperties.$dataLayer = window.dataCore;
app.config.globalProperties.$urlParams = new URLSearchParams(window.location.search);
app.config.globalProperties.$recaptchaKey = document
    .querySelector('meta[name="recaptcha-site-key"]')
    .getAttribute('content');
app.config.globalProperties.$grecaptcha = window.grecaptcha;
app.config.globalProperties.vehicleMakeList = vehicleMakeList;
app.config.globalProperties.$scrollToTop = () => window.scroll({
    top: document.getElementById('home-hero-container').offsetTop,
    left: 0,
    behavior: 'smooth',
});
app.config.globalProperties.dateToTimestamp = (date) => moment(date).format('YYYY-MM-DD HH:mm:ss');

app.config.globalProperties.$isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

const clickOutside = {
    beforeMount(el, binding) {
        // eslint-disable-next-line no-param-reassign
        binding.event = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                if (binding.value instanceof Function) {
                    binding.value(event);
                }
            }
        };
        document.body.addEventListener('click', binding.event);
    },
    unmounted(el, binding) {
        document.body.removeEventListener('click', binding.event);
    },
};

app.use(VueClickAway);
app.component('SelectInput', SelectInput);
app.component('AppButton', AppButton);
app.component('AlertView', AlertView);
app.component('NewSectionCard', NewSectionCard);
app.component('TextInput', TextInput);

app.directive('click-outside', clickOutside);
app.mount('#app');
